import React, { useEffect, useState } from "react";
import FieldSetBottom from "./FieldSetBottom";
import FieldSetTop from "./FieldSetTop";
import verified from "../../Assets/svg/verified.svg";
import { useSelector } from "react-redux";
import ModalComponent from "../modules/Modal";
import tick from "../../Assets/svg/green-bg-tick.svg";
import Button from "../modules/Button";

function PersonalDetails(props) {
  const [count, setCount] = useState({ field1: 0, field2: 0 });
  const personalCount = useSelector((state) => state.personal.count);
  const [isModal, showModal] = useState({ show: false, msg: "", type: "" });  
  return (
    <div className="form-section personal-form">
      <div className="filled-msg">
        {" "}
        <img src={verified} alt="verified" />
        <span> Note:</span> We have fetched a few details using your Aadhaar
      </div>
      <FieldSetTop
        showModal={(e) => showModal({ ...isModal, show: true, msg: e })}
        onChange={{}}
      />
      <FieldSetBottom 
      
      showModal={(e) => showModal({ ...isModal, show: true, msg: e })} onChange={{}} />
      {isModal.show && (
        <ModalComponent
          className={"disburse-model"}
          show={isModal.show}
          handleClose={() => showModal({ ...isModal, show: false })}
          // title={ModalData.title}
          // content={ModalData.desc}
          noCross={true}
          // countDown={ModalData.countDown}
        >
          <div className="modal-set">
            <div>
              {isModal.msg ===
                "Your Document has been uploaded successfully!" && (
                <img src={tick} alt="tick" />
              )}
            </div>
            <div className="md-title">
              {/* Document uploaded successfully! */}
              {isModal.msg}
            </div>
           
            <div className="modal-btn-set">
              <Button
                onClickHandler={() => showModal(false)}
                type={"contained "}
                value={"OK"}
              />
            </div>
          </div>

        </ModalComponent>
      )}
    </div>
  );
}

export default PersonalDetails;
